import {
  APP_SOCIAL_MEDIA_REQUEST,
  APP_SOCIAL_MEDIA_RESPONSE,
  APP_SOCIAL_MEDIA_FAILURE,
  APP_SOCIAL_MEDIA_UPDATE_FILTERS
} from "../../../actions/types";

const initialState = {
  isFetching: false,
  error: false,
  results: [],
  filters: {
    queryText: "",
    total: 0,
    isLayerivProfileOnly: "y",
    country: "",
    Name: "",
    grid_name: "",
    size: 25,
    from: 0,
    activePage: 1,
    sort: { key: "total_tweets", order: "desc" },
  },
};

const setRequest = (state, action) => {
  let {
    size,
    from,
    activePage,
    sort,
    queryText,
    isLayerivProfileOnly = "y",
    country = [],
    Name = "",
    grid_name = "",
    Twitter_Handle,
    tweet_relevance,
    location
  } = action.payload;

  return {
    ...state,
    isFetching: true,
    filters: {
      size,
      from,
      activePage,
      sort,
      queryText,
      isLayerivProfileOnly,
      country,
      Name,
      grid_name,
      Twitter_Handle,
      tweet_relevance,
      location
    },
  };
};

const setResponse = (state, action) => {
  let { results = [], total = 0 } = action.payload;

  return {
    ...state,
    isFetching: false,
    error: false,
    results,
    total,
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    error: true,
    results: [],
  };
};

const setFilters = (state, action) => {
  let { filters = {} } = action.payload;
  return {
    ...state,
    filters,
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_SOCIAL_MEDIA_REQUEST:
      return setRequest(state, action);

    case APP_SOCIAL_MEDIA_RESPONSE:
      return setResponse(state, action);

    case APP_SOCIAL_MEDIA_FAILURE:
      return setFailure(state, action);

    case APP_SOCIAL_MEDIA_UPDATE_FILTERS:
      return setFilters(state, action);

    default:
      return state;
  }
};
